import React, { Children } from "react";
import { Flex, Card, Input, Divider, Tabs } from "antd";
import ShopCard from './my-card';

export default ({ list = [] }) => {

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {
                list.map((item, index) => {
                    return (
                        <ShopCard content={item} key={index} />
                    )
                })
            }
        </div>
   );
};
